import React from 'react';

const About: React.FC = () => {
  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="py-20 bg-black text-white">
        <div className="section-padding">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="font-serif text-5xl md:text-6xl mb-6">Our Story</h1>
            <p className="text-xl text-gray-300 leading-relaxed">
              Founded on the principles of artistic excellence and timeless storytelling, 
              we are Kigali's premier destination for luxury photography.
            </p>
          </div>
        </div>
      </section>

      {/* Studio Story */}
      <section className="py-20 bg-white">
        <div className="section-padding">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="font-serif text-4xl mb-6">Crafting Visual Stories</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                Established in 2020, GRAPHIC ZONE STUDIO has quickly become synonymous with 
                exceptional photography in Rwanda. We specialize in creating images that 
                transcend the ordinary, capturing not just moments, but emotions and stories 
                that last a lifetime.
              </p>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                Our approach is rooted in the belief that great photography is about more 
                than technical skill—it's about understanding people, light, and the subtle 
                art of composition that transforms a simple photograph into a work of art.
              </p>
              <p className="text-gray-600 text-lg leading-relaxed">
                From intimate portraits to grand celebrations, we bring the same level of 
                dedication and artistic vision to every project, ensuring that each image 
                reflects the unique beauty of our subjects.
              </p>
            </div>
            <div>
              <img 
                src="https://images.unsplash.com/photo-1554048612-b6a482b224b8?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80" 
                alt="Studio Interior"
                className="w-full h-96 object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-studio-gray">
        <div className="section-padding">
          <div className="text-center mb-16">
            <h2 className="font-serif text-4xl md:text-5xl mb-4">Meet Our Team</h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Passionate artists and technical experts dedicated to bringing your vision to life
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12">
            {[
              {
                name: "Alex Mukamana",
                role: "Lead Photographer & Creative Director",
                image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=687&q=80",
                bio: "With over 8 years of experience in fashion and portrait photography, Alex brings an international perspective to Rwanda's photography scene."
              },
              {
                name: "Sarah Uwimana",
                role: "Portrait Specialist",
                image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=687&q=80",
                bio: "Sarah specializes in capturing the authentic essence of her subjects, creating intimate portraits that reveal true character and emotion."
              },
              {
                name: "David Nkurunziza",
                role: "Wedding & Event Photographer",
                image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80",
                bio: "David's documentary style and keen eye for candid moments make him the perfect choice for capturing life's most precious celebrations."
              }
            ].map((member, index) => (
              <div key={index} className="text-center group">
                <div className="mb-6 overflow-hidden">
                  <img 
                    src={member.image} 
                    alt={member.name}
                    className="w-full h-80 object-cover transition-all duration-500"
                  />
                </div>
                <h3 className="font-serif text-2xl mb-2">{member.name}</h3>
                <p className="text-gray-500 mb-4 font-medium">{member.role}</p>
                <p className="text-gray-600 leading-relaxed">{member.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Philosophy */}
      <section className="py-20 bg-black text-white">
        <div className="section-padding">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="font-serif text-4xl md:text-5xl mb-8">Our Philosophy</h2>
            <div className="grid md:grid-cols-3 gap-8 text-left">
              <div>
                <h3 className="font-serif text-2xl mb-4">Authenticity</h3>
                <p className="text-gray-300 leading-relaxed">
                  We believe in capturing genuine moments and real emotions, 
                  creating images that feel natural and timeless.
                </p>
              </div>
              <div>
                <h3 className="font-serif text-2xl mb-4">Excellence</h3>
                <p className="text-gray-300 leading-relaxed">
                  Every detail matters. From lighting to composition, we pursue 
                  perfection in every aspect of our craft.
                </p>
              </div>
              <div>
                <h3 className="font-serif text-2xl mb-4">Innovation</h3>
                <p className="text-gray-300 leading-relaxed">
                  We continuously evolve our techniques and embrace new 
                  technologies while honoring classic photographic principles.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;